module.exports = __webpack_public_path__ + "img/capsule_banner.cb238cc1.jpg";